import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  ToolTip,
  useFormHandler,
} from "../../../../../../../components";

import {
  TimesheetCycles,
  TimesheetFormat,
  Weekdays,
} from "../../../../../../../assets/data/enumData";
import { useDispatch } from "react-redux";
import { addNewPlacementStart } from "../../../../../../../redux/slices/placements/placementsSlice";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { v4 as uuidv4 } from "uuid";
import axiosRequest from "../../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../../redux/apiConfig";
const TimesheetDetailsTab = ({ setActiveTab, currentPlacement, editData }) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      individualTimesheets: "Individual Timesheets",
      timesheetCycles: "",
      weekStartDay: "",
      TimesheetAttachment: true,
      timesheetStartDate: "",
      allowablePeriod: "",
      timesheetFormat: 1,
      appexCalander: [
        {
          id: uuidv4(),
          // from: "",
          // to: "",
          invoinceDuration: "",
        },
      ],
    },
    {
      individualTimesheets: { type: "text", required: true },
      timesheetCycles: { type: "select", required: true },
      weekStartDay: { type: "select", required: true },
      timesheetStartDate: { type: "date", required: true },
    },
  );

  const handleSave = () => {
    const valid = validateAllFields();

    if (valid) {
      const submissionSettings = {
        cycles: formData?.timesheetCycles,
        submitMethod: 1,
        weekStartDay: formData?.weekStartDay,
        attachmentMandatory: formData?.TimesheetAttachment,
        startDate: formData?.timesheetStartDate,
        submitPeriod: formData?.allowablePeriod,
        format: formData?.timesheetFormat,
        apexDates: formData.appexCalander
          .filter((data) => data.fromDate) // only include items where fromDate exists
          .map((data) => ({
            from: data.fromDate.from,
            to: data.fromDate.to,
          })),
      };
      const uiid = fetchPerticularData?.uiid ?? "";
      const submissionData = filterEmptyValues(submissionSettings);
      dispatch(
        addNewPlacementStart({
          uiid: uiid,
          rsd: submissionData,
          rsn: "clientPlacementTimesheetDeatils",
          payload: [
            {
              type: "SET",
              value: {
                timesheetDetails: {
                  submissionSettings: {
                    ...submissionData,
                  },
                },
                apexDates: submissionData?.apexDates,
              },
            },
          ],
          onSuccess: async (payload) => {
            setActiveTab((prev) => prev + 1);
          },
        }),
      );
      // setTimeout(() => {
      //   // Move to back tab
      //   setActiveTab((prev) => prev + 1);
      // }, 500);
    } else {
      console.log("errors is the ", errors);
    }
  };
  const handleAddCalendar = () => {
    const newCalendar = {
      id: uuidv4(),
    };
    const updated = [...formData.appexCalander, newCalendar];
    handleChange("appexCalander", updated);
  };

  const handleRemoveCalendar = (id) => {
    const updated = formData.appexCalander.filter((item) => item.id !== id);
    handleChange("appexCalander", updated);
  };

  const handleCalendarChange = (id, key, value) => {
    const updated = formData.appexCalander.map((item) =>
      item.id === id ? { ...item, [key]: value } : item,
    );
    handleChange("appexCalander", updated);
  };
  // useEffect(()=>{
  //   const clientPlacementTimesheetDeatils=currentPlacement?.clientPlacementTimesheetDeatils
  //    const clientPlacementGeneral=currentPlacement?.clientPlacementGeneral
  //      if(clientPlacementGeneral){
  //    handleChange("timesheetStartDate", clientPlacementGeneral?.jobInfo?.startDate)
  //      }
  //    if(clientPlacementTimesheetDeatils){
  // handleChange("timesheetCycles", clientPlacementTimesheetDeatils?.cycles)
  // handleChange("weekStartDay", clientPlacementTimesheetDeatils?.weekStartDay)
  // handleChange("TimesheetAttachment", clientPlacementTimesheetDeatils?.attachmentMandatory)
  // handleChange("timesheetStartDate", clientPlacementTimesheetDeatils?.startDate)
  // handleChange("allowablePeriod", clientPlacementTimesheetDeatils?.submitPeriod)
  // handleChange("timesheetFormat", clientPlacementTimesheetDeatils?.format)
  //  if (Array.isArray(clientPlacementTimesheetDeatils.apexDates)) {
  //         const apexDates = clientPlacementTimesheetDeatils.apexDates.map((data) => ({
  //           fromDate: {
  //             from: data.from,
  //             to: data.to,
  //           },
  //         }));
  //         handleChange("appexCalander", apexDates);
  //       }
  // }
  // },[currentPlacement])
  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "timesheetDetails uiid apexDates jobInfo.startDate",
          },
        });
        const data = response?.data?.data;
        if (data) {
          setFetchPerticularData(data);
          handleChange("timesheetStartDate", data?.jobInfo?.startDate);
          const clientPlacementTimesheetDeatils =
            data?.timesheetDetails?.submissionSettings || {};
          const isEmptyObject = (obj) =>
            Object.keys(obj).length === 0 && obj.constructor === Object;
          if (
            clientPlacementTimesheetDeatils &&
            !isEmptyObject(clientPlacementTimesheetDeatils)
          ) {
            handleChange(
              "timesheetCycles",
              clientPlacementTimesheetDeatils?.cycles,
            );
            handleChange(
              "weekStartDay",
              clientPlacementTimesheetDeatils?.weekStartDay,
            );

            handleChange(
              "TimesheetAttachment",
              clientPlacementTimesheetDeatils?.attachmentMandatory,
            );

            handleChange(
              "allowablePeriod",
              clientPlacementTimesheetDeatils?.submitPeriod,
            );
            handleChange(
              "timesheetFormat",
              clientPlacementTimesheetDeatils?.format,
            );
          }
          if (Array.isArray(data.apexDates)) {
            const apexDates = data.apexDates.flatMap((item) =>
              Object.entries(item)
                .filter(([key]) => !isNaN(key)) // Keep only numeric keys: "0", "1", etc.
                .map(([_, value]) => ({
                  fromDate: {
                    from: value.from,
                    to: value.to,
                  },
                })),
            );
            handleChange("appexCalander", apexDates);
          }
        }
      } catch (error) {
        setFetchPerticularData(null);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);
  const ShowAppexCalander = formData.timesheetCycles === 7;
  return (
    // <div className=" px-8 py-5 border-[1px] border-neutrals-50 rounded-b  overflow-auto min-h-[65vh]">
    <div className=" px-8 py-5 border-[1px] border-neutrals-50 rounded-b  overflow-auto">
      <div className="grid  grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-8 gap-y-6 items-end">
        <div className="col-span-1">
          <FormFieldSet
            type="text"
            title={"How do you want your Employee to submit Timesheets"}
            placeholder="Individual Timesheets"
            value={formData.individualTimesheets}
            onChange={(value) => handleChange("individualTimesheets", value)}
            error={errors.individualTimesheets}
            disabled={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Timesheet Cycles"}
            placeholder="Select Timesheet Cycles"
            value={formData.timesheetCycles}
            onChange={(value) => handleChange("timesheetCycles", value)}
            error={errors.timesheetCycles}
            options={TimesheetCycles}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Week Start Day"}
            placeholder="Select Week Start Day"
            value={formData.weekStartDay}
            onChange={(value) => handleChange("weekStartDay", value)}
            error={errors.weekStartDay}
            options={Weekdays}
          />
        </div>
        <div>
          <FormFieldSet
            type="toggleInput"
            title={"Timesheet Attachment"}
            placeholder="Search for Client "
            value={formData.TimesheetAttachment}
            onChange={(value) => handleChange("TimesheetAttachment", value)}
            icon="check_circle"
            rounded="sm"
          />
        </div>
        <div>
          <FormFieldSet
            type="datepicker"
            title={"Timesheet Start Date"}
            placeholder="Select Timesheet Start Date"
            value={formData.timesheetStartDate}
            onChange={(value) => handleChange("timesheetStartDate", value)}
            error={errors.timesheetStartDate}
            disabled={true}
            showDropdown={false}
          />
        </div>
        <div>
          {ShowAppexCalander &&
            formData.appexCalander.map((item) => (
              <div key={item.id} className="flex item-center gap-4">
                <div className="flex-1">
                  <FormFieldSet
                    type="datepickerRange"
                    title="Choose Date"
                    placeholder="Select From and To Date"
                    value={item.fromDate}
                    onChange={(val) =>
                      handleCalendarChange(item.id, "fromDate", val)
                    }
                    showDropdown={false}
                  />
                </div>
                <div className="flex items-center mt-6 gap-3">
                  <Button
                    type="icon"
                    icon="add"
                    color="danger"
                    size="xs"
                    onClick={handleAddCalendar}
                  />
                  <Button
                    type="icon"
                    icon="remove"
                    color="black"
                    size="xs"
                    onClick={() => handleRemoveCalendar(item.id)}
                    disabled={formData.appexCalander.length === 1}
                  />
                </div>
              </div>
            ))}
        </div>
        <div>
          <FormFieldSet
            type="text"
            // title={"Allowable Period to Submit Timesheets"}
            title={
              <ToolTip size="sm" description={"hhh"} color="primary">
                <span className="mr-1">
                  Allowable Period to Submit Timesheets
                </span>
              </ToolTip>
            }
            placeholder="Enter Allowable Period To Submit Timesheets"
            value={formData.allowablePeriod}
            onChange={(value) => handleChange("allowablePeriod", value)}
            error={errors.allowablePeriod}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Timesheet Format"}
            placeholder="Select Timesheet Format"
            value={formData.timesheetFormat}
            onChange={(value) => handleChange("timesheetFormat", value)}
            error={errors.timesheetFormat}
            options={TimesheetFormat}
          />
        </div>
      </div>
      <div className="my-6">
        {/* <Button title={"Note: You can setup location after saving the placements."} variant="outlined"/> */}
      </div>
      <div className="flex gap-3 justify-end">
        <Button title={"Cancel"} variant="outlined" />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default TimesheetDetailsTab;
